import { cn } from "@/utils/cn";
import type { LLMConfigFormData, ModelTypeConfig } from "../types";

type ModelCapabilitySelectorProps = {
  formData: LLMConfigFormData;
  modelTypes: ModelTypeConfig[];
  activeDescription?: string;
  disabled?: boolean;
  onSelect: (key: ModelTypeConfig["key"]) => void;
};

const ModelCapabilitySelector = ({
  formData,
  modelTypes,
  activeDescription,
  disabled,
  onSelect,
}: ModelCapabilitySelectorProps) => (
  <div className="col-span-12 min-w-0 space-y-2 py-1">
    <div className="flex flex-wrap items-center gap-2.5" role="group">
      {modelTypes.map(({ key, label, icon: Icon }) => {
        const isActive = formData[key];

        return (
          <button
            type="button"
            key={key}
            data-testid={`ai-catalog-form-model-type-${key}`}
            aria-pressed={isActive}
            disabled={disabled}
            className={cn(
              "inline-flex min-h-6 items-center justify-center gap-1.5 rounded-lg border border-border bg-muted px-2 py-[3px] text-xs font-medium text-foreground outline-none transition-colors hover:bg-accent focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50",
              isActive && "border-primary text-foreground",
            )}
            onClick={() => onSelect(key)}
          >
            <Icon
              className={cn(
                "size-[13px]",
                isActive ? "text-primary" : "text-secondary-foreground",
              )}
            />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
    {activeDescription ? (
      <p className="text-xs leading-[18px] text-muted-foreground">
        {activeDescription}
      </p>
    ) : null}
  </div>
);

export default ModelCapabilitySelector;
